import { CascadiaLayout } from "@certn/cascadia-tokens";
import { createContext } from "react";

interface LayoutContextOptions {
  layout: CascadiaLayout;
  toggleMenu(open?: boolean): void;
  search?: string;
  setSearch(search?: string): void;
  menuOpen?: boolean;
  menuPosition?: "left" | "right";
  hasNavigation?: boolean;
}

export const LayoutContext = createContext<LayoutContextOptions>({
  layout: "narrow",
  toggleMenu: () => {
    console.warn(
      "toggleMenu() called but LayoutContext not found. Is your component wrapped in a Layout?"
    );
  },
  setSearch: () => {
    console.warn(
      "setSearch() called but LayoutContext not found. Is your component wrapped in a Layout?"
    );
  },
});
